.skeletonRow {
  display: flex;
  align-items: center;
  height: 44px;
  padding: 0 8px;
  gap: 12px;
}

.skeletonName {
  flex: 1;
  color: var(--color-neutral-gray-30);
}
